<div class="input-number">
    <label class="col-form-label" v-if="label" :for="id">{{ label }} <span v-if="required">(*)</span></label>
    <textarea class="form-control" :class="{ 'is-error': isError }" v-model="value" type="text" :id="id" :disabled="disabled" @blur="onBlur" :placeholder="placeholder" rows="10"/>
    <div class="error-text" v-if="errorText">{{errorText}}</div>
</div>
